export class GetSqlVmNetworkInfoResponse {
    'networkInfo';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "networkInfo",
            "baseName": "networkInfo",
            "type": "SqlVmNetworkInfo",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSqlVmNetworkInfoResponse.attributeTypeMap;
    }
    constructor() {
    }
}
